import { allTypedFieldsValid, formatPhone } from "./cpFieldRules";

const sharedSource = (item, field) => item.kind === "legacy"
  ? ["phone", "address"].includes(field.kind) ? field.kind : null
  : field.field_type === "text" && ["phone", "address"].includes(field.source_key) ? field.source_key : null;

// Only explicitly supported editable address/phone fields can share an input.
// A different saved value stays document-specific rather than being silently replaced.
export function cpBatchFieldGroups(items) {
  const entries = items.filter((item) => !item.blocked && !item.signed).flatMap((item) => {
    const fields = item.kind === "legacy" ? item.agreement.cpFields.filter((field) => !field.locked)
      : item.data.signing.fields.filter((field) => field.editable).map((field) => ({ ...field,
        source_key: item.data.document.snapshot.fields.find((saved) => saved.field_key === field.field_key)?.source_key }));
    return fields.map((field) => ({ item, field, source: sharedSource(item, field),
      key: item.kind === "legacy" ? field.key : field.field_key,
      value: item.kind === "legacy" ? field.prefill ?? "" : field.value ?? (field.field_type === "checkbox" ? false : "") }));
  });
  const groups = [];
  const byKey = new Map();
  for (const entry of entries) {
    const sameSource = entries.filter((other) => entry.source && other.source === entry.source);
    const comparable = (value) => entry.source === "phone" ? formatPhone(value) : String(value).trim();
    const equalValues = sameSource.every((other) => comparable(other.value) === comparable(entry.value));
    const shared = entry.source && equalValues;
    const key = shared ? `shared:${entry.source}` : `${entry.item.secret}:${entry.key}`;
    if (!byKey.has(key)) {
      const label = shared ? entry.source === "phone" ? "Phone" : "Address"
        : `${entry.item.kind === "legacy" ? entry.field.field?.field_name : entry.field.label}, ${entry.item.label}`;
      const input = shared ? entry.source === "address" ? "textarea" : "text"
        : entry.item.kind === "legacy" ? entry.field.input === "date" ? "legacy-date" : entry.field.input : entry.field.field_type === "checkbox" ? "checkbox" : entry.field.field_type === "date" ? "date" : "text";
      const group = { key, label, input, value: entry.value, members: [] };
      byKey.set(key, group); groups.push(group);
    }
    byKey.get(key).members.push({ secret: entry.item.secret, key: entry.key });
  }
  return groups;
}

export function cpBatchValuesFor(item, groups, values) {
  const own = {};
  for (const group of groups) for (const member of group.members) {
    if (member.secret === item.secret) own[member.key] = Object.hasOwn(values, group.key) ? values[group.key] : group.value;
  }
  return own;
}

export function cpBatchValuesValid(item, groups, values) {
  const own = cpBatchValuesFor(item, groups, values);
  if (item.kind === "legacy") return allTypedFieldsValid(item.agreement.cpFields, own);
  return item.data.signing.fields.every((field) => !field.editable || !field.required
    || (field.field_type === "checkbox" ? own[field.field_key] === true : Boolean(String(own[field.field_key] ?? "").trim())));
}
